(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["namture-coasters"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-coaster-slide]');
  if (!button) return;
  const slide = document.getElementById('CoasterPhoto-' + button.dataset.coasterSlide);
  if (slide) slide.parentElement.scrollTo({left: slide.offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
});
function initializeCoasterDots(root) {
  root.querySelectorAll('.nc-slides').forEach(function(gallery) {
    if (gallery.dataset.dotsReady) return;
    gallery.dataset.dotsReady = 'true';
    const buttons = gallery.parentElement.querySelectorAll('[data-coaster-slide]');
    function update() {
      const index = Math.round(gallery.scrollLeft / gallery.clientWidth);
      buttons.forEach(function(button, i) { button.setAttribute('aria-current', String(i === index)); });
    }
    gallery.addEventListener('scroll', update, { passive: true });
    update();
  });
}
initializeCoasterDots(document);
document.addEventListener('shopify:section:load', function(event) { initializeCoasterDots(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["namture-oil-results"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('namture-oil-results')) {
  customElements.define('namture-oil-results', class extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-ready')) return;
      const controls = this.querySelector('.nm-oil-result__switch');
      const buttons = [...this.querySelectorAll('[data-result-target]')];
      controls.hidden = false;
      this.setAttribute('data-ready', '');
      buttons.forEach(button => button.addEventListener('click', () => {
        const key = button.dataset.resultTarget;
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        this.querySelectorAll('[data-result]').forEach(figure => figure.classList.toggle('is-active', figure.dataset.result === key));
      }));
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.querySelectorAll('img').forEach(img => { img.fetchPriority = 'low'; img.loading = 'eager'; });
        this.observer.disconnect();
      }, {rootMargin:'300px'});
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["namture-problems"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('namture-problems')) {
  customElements.define('namture-problems', class extends HTMLElement {
    connectedCallback() {
      this.cleanup?.abort();
      this.cleanup = new AbortController();
      const signal = this.cleanup.signal;
      const track = this.querySelector('.nt-problems__track');
      const cards = [...this.querySelectorAll('.nt-problems__card')];
      const dots = [...this.querySelectorAll('[data-problem-index]')];
      const nav = this.querySelector('.nt-problems__dots');
      if (!track || !cards.length) return;
      nav.hidden = cards.length < 2;
      const go = (index) => {
        const padding = parseFloat(getComputedStyle(track).paddingLeft) || 0;
        const left = cards[index].getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft - padding;
        track.scrollTo({left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      const update = () => {
        const padding = parseFloat(getComputedStyle(track).paddingLeft) || 0;
        const edge = track.getBoundingClientRect().left + padding;
        let selected = 0;
        let distance = Infinity;
        cards.forEach((card, index) => {
          const current = Math.abs(card.getBoundingClientRect().left - edge);
          if (current < distance) { distance = current; selected = index; }
        });
        if (track.scrollWidth > track.clientWidth && track.scrollLeft >= track.scrollWidth - track.clientWidth - 2) selected = cards.length - 1;
        dots.forEach((dot, index) => { if(index === selected) dot.setAttribute('aria-current','true'); else dot.removeAttribute('aria-current'); });
      };
      dots.forEach((dot, index) => dot.addEventListener('click', () => go(index), {signal}));
      track.addEventListener('scroll', update, {passive:true, signal});
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const index = dots.findIndex(dot => dot.hasAttribute('aria-current'));
        go(Math.max(0,Math.min(cards.length - 1,index + (event.key === 'ArrowRight' ? 1 : -1))));
      }, {signal});
      this.addEventListener('shopify:block:select', event => {
        const index = cards.indexOf(event.target.closest('.nt-problems__card'));
        if(index >= 0) go(index);
      }, {signal});
      update();
    }
    disconnectedCallback() { this.cleanup?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["namture-warranty-page"]) return;
  try {
    
document.addEventListener('click', function(event) {
  if (event.target.closest('[data-warranty-print]')) window.print();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-faq-10"] && !Shopify.designMode) return;
  try {
    
function initNamtureFaq(root) {
  root.querySelectorAll('.namture-faq').forEach(function(faq) {
    if (faq.dataset.categoriesReady) return;
    const nav = faq.querySelector('.namture-faq__categories');
    if (!nav) return;
    const buttons = Array.from(nav.querySelectorAll('button'));
    if (!buttons.length) return;
    faq.dataset.categoriesReady = 'true';
    nav.hidden = false;
    faq.classList.add('namture-faq--categories');
    function select(category) {
      buttons.forEach(function(button) { button.setAttribute('aria-pressed', String(button.dataset.faqCategory === category)); });
      faq.querySelectorAll('.namture-faq__item').forEach(function(item) {
        item.hidden = Boolean(item.dataset.faqCategory && item.dataset.faqCategory !== category);
        if (item.hidden) item.open = false;
      });
    }
    buttons.forEach(function(button) { button.addEventListener('click', function() { select(button.dataset.faqCategory); }); });
    select(buttons[0].dataset.faqCategory);
  });
}
initNamtureFaq(document);
document.addEventListener('DOMContentLoaded', function() { initNamtureFaq(document); });
document.addEventListener('shopify:section:load', function(event) { initNamtureFaq(event.target); });
document.addEventListener('shopify:block:select', function(event) {
  const faq = event.target.closest('.namture-faq');
  if (!faq) return;
  const item = event.target.closest('.namture-faq__item');
  const selectedButton = event.target.closest('.namture-faq__category-button');
  const category = item ? item.dataset.faqCategory : selectedButton && selectedButton.dataset.faqCategory;
  if (category) {
    const button = Array.from(faq.querySelectorAll('.namture-faq__category-button')).find(function(button) { return button.dataset.faqCategory === category; });
    if (button) button.click();
  }
  if (item) item.open = true;
});

  } catch(e) { console.error(e); }
})();
})();
